module.exports = __webpack_public_path__ + "media/newstyle/images/services-footer-1-d3cbe6026566facd1be167b3ddb1ca97.png";